import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Form, FormGroup, Input, Table } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import Localization from '../../config/localization';

import * as BeneficiarySearchAction from '../../actions/BeneficiarySearch';

import * as PartnersApi from '../../api/partners';

import ArrowRightSvg from '../../components/Svg/arrowRight';
import ElectricEnergySvg from '../../components/Svg/electricEnergy';
import NaturalGasSvg from '../../components/Svg/naturalGas';

import { GetAddress } from '../../lib/address';
import Notifications from '../../lib/notifications';
import { GetName, GetUtilityTypeFromLocation, IsNaturalGas, ToNumber, ToString } from '../../lib/utils';
import { CNPValidation, ConsumptionPointValidation, PartnerCodeValidation } from '../../lib/validator';

import Loader from '../../components/Loader';

import './BeneficiarySearch.scss';
import { UTILITY_TYPE_TO_SECTOR_ID } from '../../constants/sectorId';
import { generatePath } from 'react-router';
import { Routes } from '../../constants/routes';
import { getQuantumAmount } from '../../lib/money';
import { formatDate } from '../../lib/date';
import { DEFAULT_CAEN_CODE_FOR_ASSOCIATION } from '../../constants/association';

type IProps =
  BeneficiarySearchAddition.IProps
  & ReturnType<typeof mapDispatchToProps>
  & ReturnType<typeof mapStateToProps>;

class BeneficiarySearchAddition extends React.Component<IProps, BeneficiarySearchAddition.IState> {
  state: BeneficiarySearchAddition.IState = {
    partners: [],
    search: (this.props.BeneficiarySearch && this.props.BeneficiarySearch.search) || '',
    utilityType: GetUtilityTypeFromLocation(this.props.location),

    isAssociation: false,

    loading: false,
    loadingMessage: ''
  };

  componentDidMount() {
    if (this.state.search && this.state.utilityType === (this.props.BeneficiarySearch && this.props.BeneficiarySearch.utilityType)) {
      return this._searchBeneficiary({ preventDefault: () => undefined } as React.FormEvent<HTMLFormElement>);
    }

    return undefined;
  }

  async componentWillReceiveProps(nextProps = this.props) {
    if ((this.props.location && this.props.location.pathname) !== (nextProps.location && nextProps.location.pathname)) {
      await this.setState({
        partners: [],
        search: (nextProps.BeneficiarySearch && nextProps.BeneficiarySearch.search) || '',
        utilityType: GetUtilityTypeFromLocation(nextProps.location),

        loading: false,
        loadingMessage: ''
      });

      if (this.state.search && this.state.utilityType === (this.props.BeneficiarySearch && this.props.BeneficiarySearch.utilityType)) {
        return this._searchBeneficiary({ preventDefault: () => undefined } as React.FormEvent<HTMLFormElement>);
      }

      return this.forceUpdate();
    }
  }

  renderBeneficiaries = () => {
    return this.state.partners.map(partner => {
      return partner.consumptionPoints.map(consumptionPoint => {
        const addition = consumptionPoint.additions && consumptionPoint.additions.find(Boolean);

        return (
          <tr
            className="c-pointer-no-color"
            key={consumptionPoint.consumptionPointCode}
            data-key={consumptionPoint.consumptionPointCode}
            onClick={this._go}
          >
            <td>
              <h5 className="eon-title eon-middle-grey px-1 strong mb-2 w-max-content c-text"
                  onClickCapture={this._goStopPropagation}>
                {GetName({
                  firstName: partner.firstName || partner.companyName,
                  lastName: partner.lastName || partner.companyName2
                })}
              </h5>
              <p className="eon-title eon-middle-grey px-1 w-max-content c-text"
                 onClickCapture={this._goStopPropagation}>
                {partner.partnerCode}
              </p>
            </td>
            <td>
              <h5 className="eon-title eon-middle-grey mb-2 w-max-content c-text"
                  onClickCapture={this._goStopPropagation}>
                {GetAddress(consumptionPoint.address)}
              </h5>
              <p className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._goStopPropagation}>
                {consumptionPoint.consumptionPointCode}
              </p>
              {!this.state.isAssociation ?
                <p className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._goStopPropagation}>
                  {addition && addition.personalIdentificationNumber}
                </p> : null}
            </td>
            {!this.state.isAssociation ? <td className="eon-datepicker">
              <h5 className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._goStopPropagation}>
                {addition && GetName({
                  firstName: addition.firstName,
                  lastName: addition.lastName
                })}
              </h5>
              <p className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._goStopPropagation}>
                {addition && getQuantumAmount(addition) > 0 && formatDate(addition.startDate)}
              </p>
            </td> : null}
            <td>
              <ArrowRightSvg className="m-3 c-pointer" />
            </td>
          </tr>
        );
      });
    });
  };

  renderTable = () => {
    if (!this._countBeneficiaries()) {
      return null;
    }

    return (
      <Table className="my-4 text-left bg-eon-white" hover>
        <thead>
        <tr>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.beneficiarySearchClient}</p>
            <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchClientCode}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.beneficiarySearchAdditionAddress}</p>
            <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchConsumptionAddress}</p>
            {!this.state.isAssociation ?
              <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchAdditionFiscalNumber}</p> : null}
          </th>
          {!this.state.isAssociation ? <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchAdditionName}</p>
            <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchAdditionStartDate}</p>
          </th> : null}
          <th className="align-top" scope="col" />
        </tr>
        </thead>
        <tbody>{this.renderBeneficiaries()}</tbody>
      </Table>
    );
  };

  render() {
    return (
      <Container className="beneficiary-search position-relative pb-3 px-4 my-4">
        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <div className="mt-3 d-inline-flex">
          {IsNaturalGas(this.props.location) ? <NaturalGasSvg /> : <ElectricEnergySvg />}
          <p className="eon-title eon-middle-grey my-auto text-nowrap h-100">
            {IsNaturalGas(this.props.location) ? Localization.beneficiarySearchAdditionNaturalGas : Localization.beneficiarySearchAdditionElectricEnergy}
          </p>
        </div>
        <h4 className="eon-title eon-red text-nowrap">{Localization.beneficiarySearchAdditionTitle}</h4>
        <h6 className="eon-title eon-middle-grey mt-2">{Localization.beneficiaryAdditionSearchTips}</h6>
        <Form className="mt-5 w-30" onSubmit={this._searchBeneficiary}>
          <FormGroup>
            <Input
              type="text"
              name="search"
              id="search"
              className="eon-input-text eon-input-text-no-label"
              defaultValue={
                this.state.utilityType === (this.props.BeneficiarySearch && this.props.BeneficiarySearch.utilityType)
                  ? this.state.search
                  : ''
              }
              onChange={this._setSearch}
            />
          </FormGroup>
          <button
            className="eon-button bg-eon-red eon-white mt-4" /* disabled={!this.state.search} onMouseEnter={this.WarnResult} */>
            <span className="px-4">{Localization.beneficiarySearchButton}</span>
          </button>
        </Form>

        {this.renderTable()}
      </Container>
    );
  }

  _searchValidation = () => {
    if (!PartnerCodeValidation(this.state.search) && !ConsumptionPointValidation(this.state.search) && !CNPValidation(this.state.search)) {
      throw new Error(ToString(Localization.formatString(Localization.beneficiarySearchError, this.state.search)));
    }

    return undefined;
  };

  _searchBeneficiary = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      if (!this.state.search) {
        return undefined;
      }

      await this.setState({ loading: true, partners: [] });

      this._searchValidation();

      const utilityType = GetUtilityTypeFromLocation(this.props.location);

      const { data: responseData = [] } = await PartnersApi.GetPartner({
        search: this.state.search,
        type: 'addition',
        utilityType
      });

      const partnersResponse = responseData.filter(partner => partner.consumptionPoints.find(consumptionPoint => UTILITY_TYPE_TO_SECTOR_ID[utilityType] === consumptionPoint.sectorId));

      const data = {
        partners: partnersResponse.length ? partnersResponse : [],
        loading: false
      };

      const isAssociation = !!data.partners.find(
        partner =>
          !!partner.consumptionPoints.find(
            consumptionPoint => consumptionPoint && consumptionPoint.caenCode === DEFAULT_CAEN_CODE_FOR_ASSOCIATION
          )
      );

      if (!data.partners || !data.partners.length) {
        Notifications.warning(ToString(Localization.formatString(Localization.beneficiarySearchResultsNotFound, this.state.search)));
      }

      return this.setState({ ...data, isAssociation });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _setSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    await this.setState({ search: ToString(element.value).trim() });

    await this.props.ClearSearch();

    await this.props.SetSearch(this.state.search, GetUtilityTypeFromLocation(this.props.location));

    return undefined;
  };

  _countBeneficiaries = () => {
    return this.state.partners && this.state.partners.length;
  };

  _goStopPropagation = (event: React.MouseEvent<HTMLElement>) => {
    if (!event || !event.stopPropagation) {
      return undefined;
    }
    return event.stopPropagation();
  };

  _go = async (event: React.MouseEvent<HTMLTableRowElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const consumptionPointCode = element.dataset.key as string;

    if (this.state.isAssociation) {
      return this.props.history.push(generatePath(Routes.AssociationAddition, {
        ...this.props.match.params,
        consumptionPoint: consumptionPointCode
      }));
    }

    this.state.partners.find(
      partner =>
        partner &&
        partner.consumptionPoints &&
        !!partner.consumptionPoints.find(consumptionPoint => {
          if (consumptionPoint && consumptionPoint.consumptionPointCode === consumptionPointCode) {
            const addition = (consumptionPoint.additions && consumptionPoint.additions[0]) || {};

            this.props.SetAdditionInfo(ToNumber(addition.additionId), addition.personalIdentificationNumber);

            return true;
          }
          return false;
        })
    );

    return this.props.history.push(generatePath(Routes.Addition, {
      ...this.props.match.params,
      consumptionPoint: consumptionPointCode
    }));
  };
}

const mapStateToProps = (state: General.Store) => ({ BeneficiarySearch: state.BeneficiarySearch });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...BeneficiarySearchAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BeneficiarySearchAddition);
